import React, { useEffect, useMemo } from 'react';
import { Observer } from 'mobx-react-lite';
import { useCommonContext } from '../../contexts/CommonContext';
import { useI18nContext } from '../../contexts/I18nContext';
import ProfitsStore from './ProfitsStore';
import clsx from 'clsx';
import { useStyles } from './Profits.style';
import CustomRangeRepository, { RangeName } from '../../ui_components/DateTimeRageSelect/CustomRangeRepository';
import ProfitsTab from './tabs/ProfitsTab';
import DateTimeRangeSelect from '../../ui_components/DateTimeRageSelect/DateTimeRangeSelect';

const Profits: React.FC = () => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const classes = useStyles();

    const store = useMemo<ProfitsStore>(() => new ProfitsStore(commonStore), [commonStore]);

    const customRanges = CustomRangeRepository.getRanges(i18n);
    const range = customRanges.find(t => t.key === RangeName.LAST_FIFTEEN_DAYS);
    store.setFromFilter(range!!.from!!.valueOf());
    store.setToFilter(range!!.to!!.valueOf());

    useEffect(() => {
        store.loadProfits();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onDateChange = (from: number | undefined, to: number | undefined) => {
        store.setFromFilter(from);
        store.setToFilter(to);
        store.loadProfits();
    }

    return (
        <Observer>
            {() => (
                <>
                    <div className={classes.filter_box}>
                        <DateTimeRangeSelect selectedFrom={store.from} selectedTo={store.to}
                            label={i18n.translate("DATES")}
                            className={classes.datepicker}
                            onChange={onDateChange}/>
                    </div>
                    <div className={clsx(classes.box, classes.summary_box)}>
                        <div className={classes.summary_title}>Resumen de Ganancias</div>
                        <div className={classes.summary_content}>
                            <div className={classes.summary_item}>
                                <span className={classes.summary_label}>Total de Órdenes:</span>
                                <span className={classes.summary_value}>{store.profitsSummary?.ordersAmount}</span>
                            </div>
                            <div className={classes.summary_item}>
                                <span className={classes.summary_label}>Costo Total de Compra:</span>
                                <span className={classes.summary_value}>${store.profitsSummary?.totalPurchaseCost}</span>
                            </div>
                            <div className={classes.summary_item}>
                                <span className={classes.summary_label}>Valor Total de Venta:</span>
                                <span className={classes.summary_value}>${store.profitsSummary?.totalServiceCost}</span>
                            </div>
                            <div className={classes.summary_item}>
                                <span className={classes.summary_label}>Ganancia Total:</span>
                                <span className={clsx(classes.summary_value, classes.profit_positive)}>
                                    ${store.profitsSummary?.totalProfit}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={classes.tab_container}>
                        <ProfitsTab from={store.from ?? 0} to={store.to ?? 0} />
                    </div>
                </>
            )}
        </Observer>
    );
};

export default Profits;
